export const sortObjectsByProperty = <T>(objects: T[], property: string) => {
  if (!objects || objects.length === 0) return objects;
  return objects.sort((a, b) => (a[property as keyof T] as string).localeCompare(b[property as keyof T] as string));
};

const convertDeep = (value: unknown): unknown => {
  if (value === '') return null;
  if (Array.isArray(value)) return value.map(convertDeep);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, convertDeep(v)]));
  }
  return value;
};

export const convertEmptyStringsToNull = <T extends object>(obj: T): T => convertDeep(obj) as T;
